import { render, staticRenderFns } from "./TandemSearchComponent.vue?vue&type=template&id=a60586d6&scoped=true&lang=pug"
import script from "./TandemSearchComponent.vue?vue&type=script&lang=ts"
export * from "./TandemSearchComponent.vue?vue&type=script&lang=ts"
import style0 from "./TandemSearchComponent.vue?vue&type=style&index=0&id=a60586d6&lang=scss&scoped=true"
import style1 from "./TandemSearchComponent.vue?vue&type=style&index=1&id=a60586d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60586d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a60586d6')) {
      api.createRecord('a60586d6', component.options)
    } else {
      api.reload('a60586d6', component.options)
    }
    module.hot.accept("./TandemSearchComponent.vue?vue&type=template&id=a60586d6&scoped=true&lang=pug", function () {
      api.rerender('a60586d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/TandemSearch/TandemSearchComponent.vue"
export default component.exports